import React from "react"
import "./Works.css"
import p1 from "../../img/1.jpeg"
import p2 from "../../img/2.jpeg"
import p3 from "../../img/3.jpeg"
import p4 from "../../img/4.jpeg"
import p5 from "../../img/5.jpeg"
import p6 from "../../img/19.jpeg"
import p7 from "../../img/7.jpeg"
import p8 from "../../img/8.jpeg"
import p9 from "../../img/9.jpeg"
import p10 from "../../img/10.jpeg"
import p11 from "../../img/11.jpeg"
import p12 from "../../img/12.jpeg"
import p13 from "../../img/13.jpeg"
import p14 from "../../img/20.jpeg"
import p15 from "../../img/15.jpeg"
import p16 from "../../img/17.jpeg"
import p17 from "../../img/18.jpeg"
import p18 from "../../img/21.jpeg"






const Works = () => {
  return (
    <>
      <section className='online' >
        <div className='container' id="works">
          
            <div className="Our">Few of our projects</div>
            
          <div className='grid'>
              <div className='box'>
                <div className='img'>
                  <img src={p1} alt=''/>
                  <img src={p1} alt='' className='show' />
                </div>
              </div>
              
              <div className='box'>
                <div className='img'>
                  <img src={p2} alt=''/>
                  <img src={p2} alt='' className='show' />
                </div>
              </div>

              <div className='box'>
                <div className='img'>
                  <img src={p3} alt=''/>
                  <img src={p3} alt='' className='show' />
                </div>
              </div>  
          </div>
    
          <div className='grid'>
              <div className='box'>
                <div className='img'>
                  <img src={p4} alt=''/>
                  <img src={p4} alt='' className='show' />
                </div>
                
              </div>
              
              <div className='box'>
                <div className='img'>
                  <img src={p5} alt=''/>
                  <img src={p5} alt='' className='show' />
                </div>
              </div>

              <div className='box'>
                <div className='img'>
                  <img src={p6} alt=''/>
                  <img src={p6} alt='' className='show' />
                </div>
              </div>

              
          </div>
          <div className='grid'>
              <div className='box'>
                <div className='img'>
                  <img src={p7} alt=''/>
                  <img src={p7} alt='' className='show' />
                </div>
              </div>
              
              <div className='box'>
                <div className='img'>
                  <img src={p8} alt=''/>
                  <img src={p8} alt='' className='show' />
                </div>
              </div>

              <div className='box'>
                <div className='img'>
                  <img src={p9} alt=''/>
                  <img src={p9} alt='' className='show' />
                </div>
              </div>  
          </div>
          <div className='grid'>
              <div className='box'>
                <div className='img'>
                  <img src={p10} alt=''/>
                  <img src={p10} alt='' className='show' />
                </div>
              </div>
              
              <div className='box'>
                <div className='img'>
                  <img src={p11} alt=''/>
                  <img src={p11} alt='' className='show' />
                </div>
              </div>

              <div className='box'>
                <div className='img'>
                  <img src={p12} alt=''/>
                  <img src={p12} alt='' className='show' />
                </div>
              </div>  
          </div>
          <div className='grid'>
              <div className='box'>
                <div className='img'>
                  <img src={p13} alt=''/>
                  <img src={p13} alt='' className='show' />
                </div>
              </div>
              
              <div className='box'>
                <div className='img'>
                  <img src={p14} alt=''/>
                  <img src={p14} alt='' className='show' />
                </div>
              </div>

              <div className='box'>
                <div className='img'>
                  <img src={p15} alt=''/>
                  <img src={p15} alt='' className='show' />
                </div>
              </div>  
          </div>
          <div className='grid'>
              <div className='box'>
                <div className='img'>
                  <img src={p16} alt=''/>
                  <img src={p16} alt='' className='show' />
                </div>
              </div>
              
              <div className='box'>
                <div className='img'>
                  <img src={p17} alt=''/>
                  <img src={p17} alt='' className='show' />
                </div>
              </div>

              <div className='box'>
                <div className='img'>
                  <img src={p18} alt=''/>
                  <img src={p18} alt='' className='show' />
                </div>
              </div>  
          </div>
          
        </div>
        
      </section>
      
    </>
  )
}

export default Works